import { render, staticRenderFns } from "./BoardsError.vue?vue&type=template&id=0adc7123&scoped=true"
import script from "./BoardsError.vue?vue&type=script&lang=js"
export * from "./BoardsError.vue?vue&type=script&lang=js"
import style0 from "./BoardsError.vue?vue&type=style&index=0&id=0adc7123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc7123",
  null
  
)

export default component.exports